import WelcomeSvg from '@/assets/WelcomeSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import { EmailFormProps } from '@/components/welcomePage/EmailFormDesktop.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';
import { Form } from 'react-bootstrap';

const EmailFormMobile: React.FC<EmailFormProps> = ({
  email,
  hasError,
  internalMode = false,
  isLoading,
  onChangeEmail,
  onChangePassword,
  onSubmit,
  password = '',
}) => {
  const { t } = useTranslationWithPrefix('welcomePage');

  return (
    <div className="flex w-full flex-col py-8 gap-3">
      <div className="text-center">
        <h1 className="text-4xl font-black mb-2">
          {t('heading1')} {t('heading2')}
        </h1>
        <div className="text-lg">
          <p className="text-primary m-0">{t('subheading1')}</p>
          <p className="m-0">{t('subheading2')}</p>
        </div>
      </div>

      <div className="w-full">
        <img
          alt="welcome-illustration"
          className="mx-auto h-auto w-full object-contain pr-4"
          src={WelcomeSvg}
        />
      </div>

      <p className="text-center">{t('description')}</p>

      <Form className="flex w-full flex-col gap-3" onSubmit={onSubmit}>
        <Form.Control
          className="border border-gray-300 py-2"
          onChange={onChangeEmail}
          placeholder={t('emailPlaceholder')}
          type="email"
          value={email}
        />
        {internalMode && (
          <Form.Control
            className="border border-gray-300 py-2"
            onChange={onChangePassword}
            placeholder={t('passwordPlaceholder')}
            required
            type="password"
            value={password}
          />
        )}
        {hasError && <p className="text-sm text-danger">{t('error.wentWrong')}</p>}

        <ButtonWithLoading
          className="w-full bg-primary text-white"
          isLoading={isLoading}
          type="submit"
        >
          {t('buttons.submit')}
        </ButtonWithLoading>

        <label className="flex items-start gap-2 text-xs leading-snug text-gray-500">
          <Form.Check
            className="mt-0.5 shrink-0"
            disabled={isLoading}
            id="mobile-checkbox"
            required
            type="checkbox"
          />
          <span>{t('checkboxText')}</span>
        </label>
      </Form>
    </div>
  );
};

export default EmailFormMobile;
